import { type RouteResource, createResource } from '@atlassian/react-resource-router';

import { resourceTypeCsmGlobalCustomerAccessSettings } from './resourceTypeCsmGlobalCustomerAccessSettings.tsx';
import type { CsmCustomerAccessSettingsResponse } from './CsmCustomerAccessSettingsResponse.tsx';

const ONE_DAY_IN_MILLIS = 1000 * 60 * 60 * 24;

export const csmGlobalCustomerAccessSettingsResource: RouteResource<CsmCustomerAccessSettingsResponse> =
	createResource<CsmCustomerAccessSettingsResponse>({
		type: resourceTypeCsmGlobalCustomerAccessSettings,
		getKey: ({ match }) => `settings-${match.params.projectKey || ''}`,
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-csm-customer-access-settings", jiraSpaEntry: "async-resource-csm-customer-access-settings" */ './getData.tsx'
			),
		maxAge: ONE_DAY_IN_MILLIS,
	});
